import { imageBasePath } from "lib/utils/imageUtils";
import Image from "next/image";
import InvestorsSection from "components/shared/InvestorsSection";

const pressData = [
  {
    name: "Techcrunch",
    img: "techcrunch-logo.png",
    url:
      "https://techcrunch.com/2020/03/03/leap-finance-indian-students-loans/",
    width: 100.5,
    height: 20,
  },
  {
    name: "Economic times",
    img: "economic-times-logo.png",
    url:
      "https://economictimes.indiatimes.com/small-biz/startups/newsbuzz/leap-finance-raises-5-5-million-led-by-sequoia-india/articleshow/74461279.cms",
    width: 100.5,
    height: 20,
  },
  {
    name: "Livemint",
    img: "livemint-logo.png",
    url:
      "https://www.livemint.com/companies/start-ups/education-focused-lender-leap-finance-raises-5-5-million-led-by-sequoia-11583238918949.html",
    width: 82.66,
    height: 20,
  },
  {
    name: "Yourstory",
    img: "yourstory-logo.png",
    url:
      "https://yourstory.com/2020/03/funding-fintech-startup-leap-finance-sequoia-india-kunal-shah",
    width: 82.66,
    height: 20,
  },
  {
    name: "Inc42",
    img: "inc42-logo.png",
    url:
      "https://inc42.com/startups/leap-finance-gets-sequoia-backing-to-fix-loans-for-studying-abroad/",
    width: 72,
    height: 20,
  },
  {
    name: "TechAsia",
    img: "techinasia-logo.png",
    url:
      "https://www.techinasia.com/overseas-studentsfocused-lending-platform-leap-raises-55m-sequoialed",
    width: 69.33,
    height: 20,
  },
];
const SupportersInfo = () => {
  return (
    <div className="bg-green-900">
      <div className="mx-4 py-4 grid grid-cols-3 gap-4 border-b border-teal-500 pt-12 place-items-center lg:mx-16 lg:grid-cols-6 lg:gap-16">
        {pressData.map(({ name, img, url, width, height }, idx) => (
          <a href={url} target="_blank" key={idx} rel="noreferrer">
            <Image
              src={`${imageBasePath}/assets/images/bank-page/${img}`}
              alt={name}
              width={width}
              height={height}
              className="inline-block text-gray-500 filter grayscale"
            />
          </a>
        ))}
      </div>
      <div className="text-center pb-4 md:pt-8 pt-4 mx-4 md:mx-16">
        <h2 className="font-bold pr-4 md:text-l text-sm">We are backed by :</h2>
        <InvestorsSection showBackgroundColor={false} />
      </div>
    </div>
  );
};

export default SupportersInfo;
